import { Button, Col, Row, Space } from 'antd';
import Title from '@copilot/common/typography/title';
import { useContext } from 'react';
import styled, { ThemeContext } from 'styled-components';
import { ArrowLeftOutlined } from '@ant-design/icons';
import ActiveStatus from './activeStatus';
import Text from 'antd/lib/typography/Text';
import { useHistory } from 'react-router-dom';
import { Icon } from '@iconify/react';
import { newWindowIcon } from '@copilot/common/constant/icons';

// overriding negative starting position for editable title component
const StyledEditableTitle = styled(Title)`
	margin: 0 !important;
	inset-inline-start: 0 !important;
`;

export type AccountDetailsPageHeaderProps = {
	/** name of the account */
	name: string;
	/** active status of the account*/
	status: string;
	/** whether impersonate is disabled*/
	impersonateDisabled: boolean;
	/**
	 * Handler for when impersonation is triggered
	 */
	onImpersonation: () => void;
	/** if the update name */
	updatingName?: boolean;
	/** callback on updating account name */
	onUpdateName: (accountName: string) => void;
};

/**
 * Header for account details page
 */
export function AccountDetailPageHeader({
	name,
	status,
	impersonateDisabled,
	onImpersonation,
	updatingName,
	onUpdateName,
}: AccountDetailsPageHeaderProps) {
	const theme = useContext(ThemeContext);
	const history = useHistory();

	return (
		<div
			style={{
				padding: `${theme['@spacer-size-sm']} ${theme['@spacer-size-md']}`,
				backgroundColor: 'white',
			}}
		>
			<Row align="middle" style={{ marginBottom: `${theme['@spacer-size-xs']}` }}>
				<Space size={theme['@spacer-num-xs']}>
					<Button
						icon={<ArrowLeftOutlined />}
						onClick={() => history.push('/dashboard')}
					/>
					<Text type="secondary">Back to Customer Accounts</Text>
				</Space>
			</Row>
			<Row align="middle">
				<Col style={{ display: 'flex', alignItems: 'center' }}>
					<Space size={theme['@spacer-num-xs']}>
						<StyledEditableTitle
							level={3}
							disabled={updatingName}
							editable={{ onChange: onUpdateName, tooltip: false, autoSize: true }}
						>
							{name}
						</StyledEditableTitle>
						<ActiveStatus status={status} />
					</Space>
				</Col>
				<div style={{ marginLeft: 'auto' }}>
					<Button
						type={'primary'}
						onClick={onImpersonation}
						disabled={status == 'Deactivated' || impersonateDisabled}
					>
						<Space>
							View All Campaigns{' '}
							<Icon icon={newWindowIcon} fontSize={theme['@font-size-base']} />
						</Space>
					</Button>
				</div>
			</Row>
		</div>
	);
}
